import React from "react";
import PropTypes from "prop-types";

import { ModalView, Button } from "../../simple";
import SVG from "../../SVG";

import styles from "./ModalClientUpgrade.module.scss";

const ModalClientUpgrade = ({
  isOpen,
  changeModalState,
  handleClose,
  handleUpgrade
}) => {
  return (
    <ModalView
      isOpen={isOpen}
      toggle={changeModalState}
      handleClose={handleClose}
      backdrop
      size="lg"
    >
      <div className={styles.ModalClientUpgrade}>
        <h2 className="title text-center">
          Upgrade your client to a subscription for a low Monthly price
        </h2>

        <div className={styles.grid}>
          <div>
            <SVG.CheckCircle width={32} height={32} />
            <h5 className="mb-3">Unlimited Activations</h5>
            <p>
              Activate all your audiences instead of paying per audience
              activated
            </p>
          </div>
          <div>
            <SVG.CheckCircle width={32} height={32} />
            <h5 className="mb-3">100% Freedom</h5>
            <p>
              No hassle tracking usage and costs for your client. 100% freedom
              for one fixed low price
            </p>
          </div>
        </div>

        <p className="mb-4">
          <b>What happens next?</b> The Client Subscription will be added to
          your next monthly invoice, and is ready to use when you click upgrade.
        </p>

        <Button
          onClick={handleUpgrade}
          className="button justify-content-center ml-auto mr-auto"
        >
          Upgrade
        </Button>
      </div>
    </ModalView>
  );
};

ModalClientUpgrade.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  changeModalState: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleUpgrade: PropTypes.func.isRequired
};

export default ModalClientUpgrade;
